import { props, state } from 'cerebral'
import { set } from 'cerebral/factories'
import * as actions from './actions'
import { saveEntities } from '../factories'
import { sequences as route } from '../route'
import { showFeedback } from '../feedback/factories'

export const find = [
  //
  actions.find,
  saveEntities(),
]

export const findForList = [
  //
  set(props`useRouteParams`, true),
  actions.find,
  actions.setList,
  saveEntities(),
]

export const get = [
  //
  actions.get,
  saveEntities(),
]

export const save = [
  //
  actions.save,
  actions.clearList,
  saveEntities(),
  showFeedback({ title: 'Maintenance schedule saved', type: 'success' }),
  set(props`params.id`, state`route.query.locationVehicle`),
  set(props`params.tab`, 'maintenance'),
  route.toLocationVehicleView,
]

export const remove = [
  //
  actions.remove,
  showFeedback({ title: 'Maintenance schedule deleted', type: 'success' }),
]
